<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><b>Penal Code, Article 178:<br/></b> Rehabilitation discharges additional penalties<br/>
    as well as any other penal consequence of the sentence,<br/>
    unless the law provides otherwise.<br/>
<br/>
<b>Penal Code, Article 179:</b><br/>
    Rehabilitation is acknowledged when five years have elapsed<br/>
    from the date on which the sentence is served,<br/>
    or discharged by some other means,<br/>
    and the convict has given positive<br/>
    and consistent proof of good conduct.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// GoodbyeKiss.vue?4ae7e450